// Anomalies (lot G1 v0.5.0 — B-101…B-104) : client de `/api/v1/defects`.
import { request } from './http'
import type {
  DefectCreateInput, DefectCreateResult, DefectDetail, DefectDuplicateCandidate, DefectListFilters,
  DefectListResponse, DefectPrefill, DefectTransitionInput,
} from './types/defects'

function query(params: Record<string, string | number | null | undefined>): string {
  const q = new URLSearchParams()
  for (const [cle, valeur] of Object.entries(params)) {
    if (valeur !== undefined && valeur !== null && valeur !== '') q.set(cle, String(valeur))
  }
  return q.toString()
}

export const defectsApi = {
  /** Liste filtrable (état, sévérité, version, origine), la plus récente d'abord. */
  listDefects: (workspaceId: string, filters: DefectListFilters = {}) =>
    request<DefectListResponse>(`/defects?${query({
      workspace_id: workspaceId, state: filters.state, severity: filters.severity, version: filters.version,
      origin: filters.origin,
    })}`),
  /** Détail : journal, exécutions reliées, transitions expliquées avant le clic. */
  getDefect: (workspaceId: string, id: number) =>
    request<DefectDetail>(`/defects/${id}?${query({ workspace_id: workspaceId })}`),
  /** Déclaration humaine libre, ou depuis une exécution rouge (idempotente). */
  createDefect: (input: DefectCreateInput) =>
    request<DefectCreateResult>('/defects', { method: 'POST', body: JSON.stringify(input) }),
  /** Transition : la cible exige sa preuve ; un refus revient avec son code nommé. */
  transitionDefect: (id: number, input: DefectTransitionInput) =>
    request<DefectDetail>(`/defects/${id}/transitions`, { method: 'POST', body: JSON.stringify(input) }),
  /** Formulaire pré-rempli depuis une exécution (cas, sortie, version, environnement). */
  getDefectPrefill: (workspaceId: string, executionId: number) =>
    request<DefectPrefill>(`/defects/prefill?${query({ workspace_id: workspaceId, execution_id: executionId })}`),
  /** V761 : rattache UNE fois au cas de recette dont elle est née une anomalie déclarée sans cas. */
  linkDefectTestCase: (id: number, input: { workspace_id: string; test_case_id: number }) =>
    request<DefectDetail>(`/defects/${id}/test-case`, { method: 'PATCH', body: JSON.stringify(input) }),
  /** Doublons possibles, avec score : pour une anomalie existante ou un titre en saisie. */
  listDefectDuplicateCandidates: (workspaceId: string, criteria: { defectId?: number | undefined; title?: string | undefined; actual?: string | undefined }) =>
    request<DefectDuplicateCandidate[]>(`/defects/duplicate-candidates?${query({
      workspace_id: workspaceId, defect_id: criteria.defectId, title: criteria.title, actual: criteria.actual,
    })}`),
}
